// extracted by mini-css-extract-plugin
export default {"card":"X7Q46","title":"XGyQD"};